__turbopack_context__.v({
  "detail": "btUv4W_detail",
  "footnote": "btUv4W_footnote",
  "lede": "btUv4W_lede",
  "mono": "btUv4W_mono",
  "notes": "btUv4W_notes",
  "recordText": "btUv4W_recordText",
  "scrollPane": "btUv4W_scrollPane",
  "tableScroll": "btUv4W_tableScroll",
});
